import { forwardRef, useCallback, useEffect } from "react"
import { useExternalRef } from "@tm/utils"
import { NumberField, NumberFieldProps } from "./NumberField"

type CurrencyFieldProps = Omit<NumberFieldProps, "isAllowed" | "decimalScale" | "fixedDecimalScale">

export const CurrencyField = forwardRef<HTMLDivElement, CurrencyFieldProps>((props, ref) => {
    const inputRef = useExternalRef(props.inputRef)
    const handleChange = useCallback((value: number | undefined, event?: React.SyntheticEvent<HTMLInputElement>) => {
        if (value === undefined) {
            props.onChange(0, event)
            return
        }
        props.onChange(value, event)
    }, [])

    useEffect(() => {
        if (props.value === 0 && document.activeElement === inputRef.current) {
            inputRef?.current.select()
        }
    }, [props.value])

    return <NumberField ref={ref} decimalScale={2} fixedDecimalScale {...props} onChange={handleChange} inputRef={inputRef} />
})
